import React from 'react';
import PropTypes from 'prop-types';
import './HistoryDetail.css'; // Asegúrate de tener estilos adecuados para tu componente

const HistoryDetail = ({ history, filterParam, filterValue, handleClose }) => {
  let filteredHistory = [];

  if (Array.isArray(history) && history.length > 0) {
    filteredHistory = history.filter(item => item[filterParam] === filterValue);
  }

  const isEmptyOrNull = (value) => value === null || value === undefined || value === '';

  return (
    <div className="history-detail">
      <div>
        <h2>Historial Filtrado</h2>
        {filteredHistory.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Fecha Programada</th>
                <th>Estado</th>
                <th>Observación</th>
                <th>Timestamp</th>
              </tr>
            </thead>
            <tbody>
              {filteredHistory.map(item => (
                <tr key={item.Id_History}>
                  <td>{isEmptyOrNull(item.Name_User) ? 'N/A' : item.Name_User}</td>
                  <td>{isEmptyOrNull(item.Scheduled_Date) ? 'N/A' : item.Scheduled_Date}</td>
                  <td>{isEmptyOrNull(item.Status) ? 'N/A' : item.Status}</td>
                  <td>{isEmptyOrNull(item.Observation) ? 'N/A' : item.Observation}</td>
                  <td>{isEmptyOrNull(item.Timestamp) ? 'N/A' : item.Timestamp}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No se encontraron registros para el filtro especificado.</p>
        )}
      </div>
      <div>
        <button onClick={handleClose}> Cerrar </button>
      </div>
    </div>
  );
};

HistoryDetail.propTypes = {
  history: PropTypes.arrayOf(PropTypes.shape({
    Id_History: PropTypes.number.isRequired,
    Description_Task: PropTypes.string.isRequired,
    Name_Machine: PropTypes.string.isRequired,
    Name_Emp: PropTypes.string.isRequired,
    Name_User: PropTypes.string.isRequired,
    Scheduled_Date: PropTypes.string.isRequired,
    Status: PropTypes.string.isRequired,
    Priority: PropTypes.string.isRequired,
    Observation: PropTypes.string.isRequired,
    Timestamp: PropTypes.string.isRequired,
  })).isRequired,
  filterParam: PropTypes.string.isRequired,
  filterValue: PropTypes.any.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default HistoryDetail;
